export default __webpack_public_path__ + "static/media/poppy_solution.png.webp";